(function () {
  var GAP = 24;

  function perView() {
    var w = window.innerWidth;
    if (w < 640) return 2;
    if (w < 1024) return 3;
    return 4;
  }

  function init(root) {
    if (!root || root.getAttribute('data-ready') === 'true') return;

    var viewport = root.querySelector('[data-testimonials-viewport]');
    var track = root.querySelector('[data-testimonials-track]');
    var prev = root.querySelector('[data-testimonials-prev]');
    var next = root.querySelector('[data-testimonials-next]');
    var dotsWrap = root.querySelector('[data-testimonials-dots]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];

    if (!viewport || !track || slides.length === 0) return;
    root.setAttribute('data-ready', 'true');

    var index = 0;
    var pv = perView();
    var autoTimer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoSpeed = Number(root.getAttribute('data-autoplay-speed') || 6) * 1000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function maxIndex() {
      return Math.max(0, slides.length - pv);
    }

    function layout() {
      pv = perView();
      var width = viewport.clientWidth;
      var slideW = Math.max(120, (width - GAP * Math.max(pv - 1, 0)) / pv);

      slides.forEach(function (slide) {
        slide.style.flex = '0 0 ' + slideW + 'px';
        slide.style.width = slideW + 'px';
        slide.style.maxWidth = slideW + 'px';
      });

      track.style.gap = GAP + 'px';
      if (index > maxIndex()) index = maxIndex();
      goTo(index, false);
      updateChrome();
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(i, maxIndex()));
      var slideW = slides[0].getBoundingClientRect().width;
      var offset = index * (slideW + GAP);
      track.style.transition = animate === false || reduceMotion ? 'none' : 'transform .55s cubic-bezier(.22, 1, .36, 1)';
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      updateChrome();
    }

    function updateChrome() {
      var needsNav = slides.length > pv;
      if (prev) {
        prev.hidden = !needsNav;
        prev.disabled = index <= 0;
      }
      if (next) {
        next.hidden = !needsNav;
        next.disabled = index >= maxIndex();
      }

      if (!dotsWrap) return;
      if (!needsNav) {
        dotsWrap.hidden = true;
        dotsWrap.innerHTML = '';
        return;
      }

      var pages = maxIndex() + 1;
      dotsWrap.hidden = false;
      if (dotsWrap.children.length !== pages) {
        dotsWrap.innerHTML = '';
        for (var d = 0; d < pages; d++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'saha-testimonials__dot';
          btn.setAttribute('aria-label', 'Go to slide group ' + (d + 1));
          btn.setAttribute('data-index', String(d));
          dotsWrap.appendChild(btn);
        }
      }
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function startAuto() {
      stopAuto();
      if (!autoplay || reduceMotion || slides.length <= pv) return;
      autoTimer = window.setInterval(function () {
        if (index >= maxIndex()) goTo(0, true);
        else goTo(index + 1, true);
      }, autoSpeed);
    }

    function stopAuto() {
      if (autoTimer) {
        window.clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1, true);
        startAuto();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1, true);
        startAuto();
      });
    }
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-index]');
        if (!btn) return;
        goTo(Number(btn.getAttribute('data-index')), true);
        startAuto();
      });
    }

    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      deltaX = 0;
      track.style.transition = 'none';
      stopAuto();
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      deltaX = e.clientX - startX;
      var slideW = slides[0].getBoundingClientRect().width;
      var base = index * (slideW + GAP);
      track.style.transform = 'translate3d(' + -(base - deltaX) + 'px, 0, 0)';
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (deltaX > 40) goTo(index - 1, true);
      else if (deltaX < -40) goTo(index + 1, true);
      else goTo(index, true);
      startAuto();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        layout();
        startAuto();
      }, 120);
    });

    layout();
    startAuto();
  }

  function boot() {
    document.querySelectorAll('[data-testimonials]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-testimonials]');
    if (!root) return;
    root.removeAttribute('data-ready');
    init(root);
  });
})();
